import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type NotEnoughCHZDrawerProps = {
	closeModal: () => void;
	minAmount?: string;
	testID: string;
};

export const NotEnoughCHZDrawer = ({ closeModal, minAmount, testID }: NotEnoughCHZDrawerProps) => {
	const { $t } = useIntl();

	const notEnoughCHZDrawerData = {
		buttonText: $t('wallet.withdraw.notEnoughCHZDrawer.buttonText'),
		description: $t('wallet.withdraw.notEnoughCHZDrawer.description', { minAmount }),
		image: GoatAwkward,
		testID: testID,
		title: $t('wallet.withdraw.notEnoughCHZDrawer.title')
	};

	return <GenericDrawer {...notEnoughCHZDrawerData} onButtonPress={closeModal}></GenericDrawer>;
};
